var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrustpilotRatings1StarRgb = function SvgTrustpilotRatings1StarRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 18,
    viewBox: "0 0 96 18"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_1star-RGB_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.172 0H19v18H.172Zm0 0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "Trustpilot_ratings_1star-RGB_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77 0h18.746v18H77Zm0 0"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_1star-RGB_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#1e1e1e",
      fillOpacity: 1
    },
    d: "M18.09 0H.172v18H18.09Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M37.504 0H19.586v18h17.918ZM56.918 0H39v18h17.918ZM76.332 0H58.41v18h17.922Zm0 0"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Trustpilot_ratings_1star-RGB_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#dcdce6",
      fillOpacity: 1
    },
    d: "M95.746 0H77.824v18h17.922Zm0 0"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "#fff",
      fillOpacity: 1
    },
    d: "m9.133 12.133 2.722-.695 1.141 3.523Zm6.27-4.559h-4.798L9.133 3.04 7.656 7.574H2.86l3.883 2.813-1.472 4.539 3.878-2.813 2.391-1.726ZM28.547 12.133l2.723-.695 1.14 3.523Zm6.27-4.559H30.02L28.547 3.04 27.07 7.574h-4.797l3.883 2.813-1.476 4.539 3.883-2.813 2.39-1.726ZM47.957 12.133l2.727-.695 1.14 3.523Zm6.273-4.559h-4.796L47.957 3.04l-1.473 4.535h-4.797l3.883 2.813-1.476 4.539 3.883-2.813 2.39-1.726ZM67.371 12.133l2.727-.695 1.136 3.523Zm6.274-4.559h-4.797L67.37 3.04l-1.473 4.535h-4.796l3.878 2.813-1.472 4.539 3.883-2.813 2.39-1.726ZM86.785 12.133l2.727-.695 1.136 3.523Zm6.274-4.559h-4.801L86.785 3.04 85.31 7.574h-4.797l3.883 2.813-1.473 4.539 3.883-2.813 2.386-1.726Zm0 0"
  }));
};
export default SvgTrustpilotRatings1StarRgb;